export const ListActionTypes = {
  blur: 'list:blur',
  focus: 'list:focus',
  itemClick: 'list:itemClick',
  itemHover: 'list:itemHover',
  itemsChange: 'list:itemsChange',
  keyDown: 'list:keyDown',
  resetHighlight: 'list:resetHighlight',
  textNavigation: 'list:textNavigation'
};

/**
 * A union of all standard actions that can be dispatched to the list reducer.
 */


// WEBPACK FOOTER //
// ./node_modules/@mui/base/useList/listActions.types.js